import { IModuleProps } from '../../core/utils/modules';

export default {
    name: 'ruko',
} as IModuleProps;
